/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RevenueCalculatorConfigDto } from '../../models/revenue-calculator-config-dto';
import { UpdateRevenueCalculatorConfigDto } from '../../models/update-revenue-calculator-config-dto';

export interface RevenueCalculatorConfigControllerUpdate$Params {
  storeId: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
  body: UpdateRevenueCalculatorConfigDto;
}

export function revenueCalculatorConfigControllerUpdate(
  http: HttpClient,
  rootUrl: string,
  params: RevenueCalculatorConfigControllerUpdate$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<RevenueCalculatorConfigDto>> {
  const rb = new RequestBuilder(rootUrl, revenueCalculatorConfigControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RevenueCalculatorConfigDto>;
    })
  );
}

revenueCalculatorConfigControllerUpdate.PATH = '/api/v1/stores/{storeId}/revenue-calculator-config';
